
import OriginalWork from "@/components/post/OriginalWork.vue";
import WorkAudio from "@/components/post/WorkAudio.vue";
import PostComment from "@/components/PostComment.vue";
import WorkNote from "@/components/post/WorkNote.vue";
import WorkImage from "@/components/post/WorkImage.vue";
import WorkVideo from "@/components/post/WorkVideo.vue";
import PostBottomBar from "@/components/PostBottomBar.vue";
import CommentPostPopup from "@/components/CommentPostPopup.vue";
import { SPECIAL_CHANNEL_ID } from "@/utils/constants";
import { User, Post, Topic } from "@/models";
import Toast from 'vux/src/components/toast/index.vue'

import { mapGetters } from "vuex";

export default {
name: "post",
async created() {
let id = this.$route.params.id;
let topicId = this.$route.query.topic;

if (!id) {
return;
}

let post = await Post.getById(id);
let user = post.user;

if (user.isClosed) {
return;
}
this.post = post;

if (topicId) {
this.topic = await Topic.getById(topicId);
}

this.$initWechat().then(() => {
this.$initWechatShare({
title: this.title,
link: location.href,
image: this.post.image ? this.post.image.url : this.post.user.avatar.url,
desc: this.description,
});
});

this.getComments(id);

if (User.current()) {
Post.checkLiked(id).then((liked) => {
this.liked = liked;
});
}
},
scrollBottom() {
this.getComments(this.post.objectId, this.page + 1);
},
mounted() {},
data() {
return {
post: null,
topic: null,
liked: false,
comments: [],
targetComment: null,
SPECIAL_CHANNEL_ID: SPECIAL_CHANNEL_ID,
showCommentPopup: false,
showSubmitSuccessTip: false,
page: 1,
loading: false,
};
},
metaInfo() {
return {
title: this.title,
titleTemplate: null,
meta: [{ name: "description", content: this.description }],
};
},
computed: {
...mapGetters(["user"]),

title: function () {
if (!this.post) {
return "西窗烛";
}

if (this.post.title) {
return this.post.title;
}

var title = "";

if (this.post.channel) {
var channelId = this.post.channel.objectId;

if (channelId == SPECIAL_CHANNEL_ID.ORIGINAL_WORK) {
title = `${this.post.user.username}的创作《${this.post.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.WORK_AUDIO) {
title = `${this.post.user.username}的朗读《${this.post.work.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.WORK_MUSIC) {
title = `${this.post.user.username}的音乐《${this.post.work.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.WORK_WRITING) {
title = `${this.post.user.username}的字《${this.post.work.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.WORK_PAINTING) {
title = `${this.post.user.username}的绘画《${this.post.work.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.WORK_PICTURE) {
title = `${this.post.user.username}的配图《${this.post.work.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.WORK_NOTE) {
title = `${this.post.user.username}的笔记《${this.post.work.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.WORK_VIDEO) {
title = `${this.post.user.username}的视频《${this.post.work.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.DAILY_WORK) {
title = `${this.post.user.username}的日赏《${this.post.work.title}》· `;
} else if (channelId == SPECIAL_CHANNEL_ID.WORK_ESSAY) {
title = `${this.post.user.username}的随笔`;

if (this.post.work) {
title += `《${this.post.work.title}》· `;
} else {
title += " · ";
}
}
}

if (this.topic) {
title += this.topic.title;
} else {
title += "西窗烛";
}

return title;
},
description: function () {
if (!this.post) {
return "";
}

let desc = "";

if (this.post.channel.objectId == SPECIAL_CHANNEL_ID.ORIGINAL_WORK) {
desc = this.post.text;
} else if (
this.post.channel.objectId == SPECIAL_CHANNEL_ID.WORK_AUDIO ||
this.post.channel.objectId == SPECIAL_CHANNEL_ID.WORK_MUSIC
) {
desc = this.post.work.content;
}

return desc.replace(/\n/g, "");
},
isHuawei: function () {
return this.$route.query.pro;
},
},
methods: {
comment: function () {
if (!this.user) {
return;
}

this.showCommentPopup = true;
},

commentAt: function (comment) {
if (!this.user) {
return;
}

this.targetComment = comment;
this.showCommentPopup = true;
},

postLiked: function () {
this.liked = true;
this.post.likesCount += 1;
},

postUnliked: function () {
this.liked = false;
this.post.likesCount -= 1;
},

submitComment: function (comment) {

this.showCommentPopup = false;
this.post.commentsCount += 1;
this.comments.splice(0, 0, comment);
window.scrollTo(0, 0);
},

deleteComment: function (comment) {
this.comments = this.comments.filter((c) => c.objectId != comment.objectId);
},

getComments: function (postId, page = 1) {
if (this.loading) {
return Promise.reject("Loading");
}

this.loading = true;

return Post.getComments(postId, page)
.then((comments) => {
if (page == 1) {
this.comments = comments;
} else {
this.comments = this.comments.concat(comments);
}

this.page = page;
this.loading = false;
})
.catch(() => {
this.loading = false;
});
},
},
components: {
"original-work": OriginalWork,
"post-comment": PostComment,
"post-bottom-bar": PostBottomBar,
CommentPostPopup,
Toast,
WorkAudio,
WorkNote,
WorkImage,
WorkVideo,
},
};



// WEBPACK FOOTER //
// ./src/pages/Post.vue